import { render, staticRenderFns } from "./TravelTypeList.vue?vue&type=template&id=ff9375f4&scoped=true&"
import script from "./TravelTypeList.vue?vue&type=script&lang=js&"
export * from "./TravelTypeList.vue?vue&type=script&lang=js&"
import style0 from "./TravelTypeList.vue?vue&type=style&index=0&id=ff9375f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9375f4",
  null
  
)

export default component.exports